module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN WRITING THIS BOOK")]), _vm._v(" I enjoyed the great support of Malcolm Bilson, and I cannot thank him enough for his enthusiasm and all the time he devoted to reading and commenting on the chapters. His interest and his valuable suggestions were most welcome. The book was first improved by Bruce Cooper-Clarke, who unselfishly took the time to read my typescripts and suggest better and shorter ways of expression. For commentaries I owe thanks also to Paul Badura-Skoda; for his and for Peter Gülke’s encouragement I am most grateful. I am also grateful for the support of Carlo Grante and Helen Heslop. Their enthusiasm was a great help, and Helen’s command of American English improved the text. John Koster and Ulrich Leisinger too commented on my manuscript and discovered errors. Koster especially deserves my thanks, because he gave me confidence that the book merits attention, and his hospitality in Vermillion was a wonderful experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks are also due to Raina Polivka of Indiana University Press, who in many ways made the book more readable; for instance, she allowed footnotes and did not insist on notes hidden somewhere in the book. I am sure my readers will thank her for this decision.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d53e53a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgement.vue
// module id = 72
// module chunks = 0